/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_CatalogInputs */

const cs_templates_empty_catalog = /** @type {(inputs: Templates_Empty_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné katalogové PDF šablony.`)
};

const en_templates_empty_catalog = /** @type {(inputs: Templates_Empty_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No catalog PDF templates yet.`)
};

/**
* | output |
* | --- |
* | "No catalog PDF templates yet." |
*
* @param {Templates_Empty_CatalogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_catalog = /** @type {((inputs?: Templates_Empty_CatalogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_CatalogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_catalog(inputs)
	return cs_templates_empty_catalog(inputs)
});